import TypedEventEmitter from '@client-shared/utils/typed-event-emitter'
import type { GeospatialDataGroupRecord } from './types'

type OriginContext = 'group-selector' | 'file-library'

export interface OriginDestinationTypedEvents {
	'file-library:add': { record: GeospatialDataGroupRecord; origin_context: OriginContext }
	'file-library:update': { record: GeospatialDataGroupRecord; origin_context: OriginContext }
	'file-library:delete': { record: GeospatialDataGroupRecord; origin_context: OriginContext }
}

export const od_event_emitter = new TypedEventEmitter<OriginDestinationTypedEvents>()
